import React from 'react';
import * as S from './FooterBlck.styles';
import CustomerNeeds from './CustomerNeeds/CustomerNeeds';
import WaitingFor from './WaitingFor/WaitingFor';
import FooterNew from './FooterNew/FooterNew';
import FaqsNew from './FaqsNew/Faqs';
import {faqData, faqHeading, lobFAQData} from './faqData';

const FooterBlock = ({timeZone, lob}) => {
  const currentYear = new Date().getFullYear();

  const footerFaqHeading =
    lobFAQData && lobFAQData[lob] && lobFAQData[lob]['heading']
      ? lobFAQData[lob]['heading']
      : faqHeading;
  const footerFaqData =
    lobFAQData && lobFAQData[lob] && lobFAQData[lob]['data'] ? lobFAQData[lob]['data'] : faqData;

  return (
    <S.FooterBlockMainWrap>
      <S.FooterOuterWrap>
        <S.FooterBlockInnerWrap>
          {!timeZone && <CustomerNeeds />}
          <WaitingFor />
          {timeZone && (
            <S.CopyrightTagWrap>
              <S.CopyrightTag>@2023 Makemytrip</S.CopyrightTag>
            </S.CopyrightTagWrap>
          )}
        </S.FooterBlockInnerWrap>
      </S.FooterOuterWrap>
      {!timeZone && (
        <FaqsNew
          heading={'Frequently Asked Questions'}
          faqData={footerFaqData}
          faqHeadingData={footerFaqHeading}
        />
      )}
      {!timeZone && (
        <FooterNew
          copyText={`© ${currentYear} MakeMyTrip (India) Limited`}
          country={!timeZone ? 'INDIA' : 'UAE'}
        />
      )}
    </S.FooterBlockMainWrap>
  );
};

export default FooterBlock;
